module.exports = __webpack_public_path__ + "img/transfer.3249b391.svg";